// extracted by mini-css-extract-plugin
module.exports = {"container":"SignupFormStyle_container__QQkTN","message":"SignupFormStyle_message__3sirP","label":"SignupFormStyle_label__1Ocl0","error":"SignupFormStyle_error__1qeMZ"};